import React, { useState } from "react";
import {
  Stack,
  Typography,
  Checkbox,
  MenuItem,
  useMediaQuery,
  DialogContent,
  DialogActions,
  Grid,
} from "@mui/material";
import * as yup from "yup";
import { useFormik } from "formik";
import { useMutation, useQuery } from "react-query";
import { addBookGroup, getBooksForSale } from "app/services/ledgerAccount";
import { toast } from "react-toastify";
import {
  CustomSelectBox,
  CustomTextField,
} from "assets/styles/globalStyledComponent";
import TextFieldLabel from "app/components/common/TextFieldLabel";
import { IndianCurrency, MenuProps } from "app/utils/helper";
import Chip from "app/components/common/CustomChip";
import { LoadingButton } from "@mui/lab";
import CustomLoader from "app/components/common/CustomLoader";
const CustomizeBookContent = ({ refetch, classData = [], dialogClose }) => {
  const [state, setState] = useState({
    tableData: [],
    selectedClass: "",
    selectedSeller: "",
    customize: {
      class: "",
      section: "",
      gName: "",
      bookList: [],
    },
    section: "",
  });
  const isMobile = useMediaQuery("(max-width: 768px)");
  const formikCustomize = useFormik({
    initialValues: {
      class: "",
      section: "",
      groupName: "",
      list: [],
    },
    validationSchema: yup.object({
      class: yup.string().required("Class is required"),
      section: yup.string().required("Section is required"),
      groupName: yup.string().required("Group Name is required"),
      list: yup.array().required("Please Select some books"),
    }),
    onSubmit: (values) => {
      addBookGroupMutate({
        classDocId: values.class,
        section: values.section,
        bookGroupName: values.groupName,
        bookForSaleDocIdList: values.list,
      });
      formikCustomize.resetForm();
    },
  });
  const bookList = state?.tableData?.map((item) => ({
    id: item._id,
    title: item.bookTitle,
    sRate: item?.sellingRate,
    bRate: item?.buyingRate,
  }));
  const getBookData = (id) => bookList?.filter((item) => item.id === id)[0];
  const sections = (data) => {
    return classData?.filter((item) => item.classDocId === data)[0]?.sections;
  };
  const { mutate: addBookGroupMutate, isLoading: addBookGroupLoading } =
    useMutation(addBookGroup, {
      onSuccess: (res) => {
        toast.success(res?.data?.message);
        refetch();
        dialogClose();
        formikCustomize.resetForm();
      },
      onError: (err) => {
        toast.error(err?.response?.data?.message);
      },
    });

  const {
    data: getBookForSaleCustomizeData,
    isLoading: getBooksForSaleCustomizeLoading,
    isFetching: getBooksForSaleCustomizeFetching,
  } = useQuery({
    queryKey: ["getBooksForSaleCustomize", state?.customize?.section],
    queryFn: () =>
      getBooksForSale({
        classDocId: formikCustomize.values.class,
        section: formikCustomize.values.section,
      }),
    onSuccess: (res) => {
      setState((prev) => ({ ...prev, tableData: res?.data?.list }));
    },
    onError: (err) => {
      toast.error(err?.response?.data?.message);
    },
    enabled: formikCustomize.values.section ? true : false,
  });
  return (
    <>
      <CustomLoader
        show={
          getBooksForSaleCustomizeLoading || getBooksForSaleCustomizeFetching
        }
      />
      <form id="customizeForm" onSubmit={formikCustomize.handleSubmit}>
        <Stack pt={1.5}>
          <Grid container rowSpacing={2} columnSpacing={1}>
            <Grid item xs={12} md={4}>
              <TextFieldLabel title={"CLass-Stream"} required />
              <CustomSelectBox
                native
                MenuProps={MenuProps}
                sx={{ width: "100%" }}
                displayEmpty
                name="class"
                value={formikCustomize.values.class}
                onChange={(e) => {
                  formikCustomize.setValues((prev) => ({
                    ...prev,
                    section: "",
                    class: e.target.value,
                  }));
                  setState((prev) => ({
                    ...prev,
                    customize: {
                      ...prev.customize,
                      class: e.target.value,
                      sections: sections(e.target.value),
                      section: "",
                    },
                  }));
                }}
              >
                <MenuItem disabled value="" component="option">
                  Select
                </MenuItem>
                {classData?.map((item) => (
                  <MenuItem value={item.classDocId} component="option">
                    {item?.className_stream}
                  </MenuItem>
                ))}
              </CustomSelectBox>
              {formikCustomize.errors.class &&
                formikCustomize.touched.class && (
                  <Typography sx={{ color: "red" }}>
                    {formikCustomize.errors.class}
                  </Typography>
                )}
            </Grid>
            <Grid item xs={12} md={4}>
              <TextFieldLabel title={"Section"} />
              <CustomSelectBox
                native
                MenuProps={MenuProps}
                sx={{ width: "100%" }}
                name="section"
                disabled={!formikCustomize.values.class}
                displayEmpty
                value={formikCustomize.values.section}
                onChange={(e) => {
                  formikCustomize.setValues((prev) => ({
                    ...prev,
                    section: e.target.value,
                    list: [],
                  }));

                  setState((prev) => ({
                    ...prev,
                    customize: {
                      ...prev.customize,
                      section: e.target.value,
                    },
                  }));
                }}
              >
                <MenuItem disabled value="" component="option">
                  Select
                </MenuItem>
                {state?.customize?.sections?.map((item) => (
                  <MenuItem value={item} component="option">
                    {item}
                  </MenuItem>
                ))}
              </CustomSelectBox>
              {formikCustomize.errors.section &&
                formikCustomize.touched.section && (
                  <Typography sx={{ color: "red" }}>
                    {formikCustomize.errors.section}
                  </Typography>
                )}
            </Grid>
            <Grid item xs={12} md={4}>
              <TextFieldLabel title={"Group Name"} />

              <CustomTextField
                fullWidth
                placeholder="Enter Group Name"
                name="groupName"
                value={formikCustomize.values.groupName}
                onChange={(e) => {
                  formikCustomize.handleChange(e);
                  setState((prev) => ({
                    ...prev,
                    customize: {
                      ...prev.customize,
                      gName: e.target.value,
                    },
                  }));
                }}
              />
              {formikCustomize.errors.groupName &&
                formikCustomize.touched.groupName && (
                  <Typography sx={{ color: "red" }}>
                    {formikCustomize.errors.groupName}
                  </Typography>
                )}
            </Grid>
            <Grid item xs={12} md={4}>
              <TextFieldLabel title={"Book Title"} />
              <CustomSelectBox
                renderValue={(selected) => {
                  if (formikCustomize.values.list?.length > 0) {
                    return formikCustomize.values.list
                      ?.map((book) => getBookData(book)?.title)
                      .join(", ");
                  }
                  return <Typography>Select</Typography>;
                }}
                sx={{ width: isMobile ? "100%" : "17rem" }}
                MenuProps={MenuProps}
                name="list"
                multiple={true}
                value={formikCustomize.values.list}
              >
                <MenuItem disabled value="">
                  Select
                </MenuItem>
                {getBookForSaleCustomizeData?.data?.list?.map((book) => (
                  <MenuItem
                    value={book?._id}
                    onClick={() => {
                      if (formikCustomize.values.list.includes(book?._id)) {
                        formikCustomize.setValues((prev) => ({
                          ...prev,
                          list: prev.list.filter((res) => res !== book?._id),
                        }));
                      } else {
                        formikCustomize.setValues((prev) => ({
                          ...prev,
                          list: [...prev.list, book._id],
                        }));
                      }
                    }}
                    sx={{
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                    }}
                  >
                    <Stack direction="row" alignItems="center">
                      <Checkbox
                        checked={formikCustomize.values.list.includes(
                          book?._id
                        )}
                      />
                      <Typography>{`${book?.bookTitle} (${IndianCurrency(
                        book?.sellingRate
                      )})`}</Typography>
                    </Stack>
                  </MenuItem>
                ))}
              </CustomSelectBox>
              {formikCustomize.errors.list && formikCustomize.touched.list && (
                <Typography sx={{ color: "red" }}>
                  {formikCustomize.errors.list}
                </Typography>
              )}
            </Grid>
          </Grid>
          <Stack
            direction="row"
            my={2}
            gap={2}
            alignItems="center"
            flexWrap="wrap"
          >
            {formikCustomize.values.list?.map((book) => (
              <Chip
                title={`${getBookData(book)?.title} (${IndianCurrency(
                  getBookData(book)?.sRate
                )}) /-`}
                handleClose={() =>
                  formikCustomize.setValues((prev) => ({
                    ...prev,
                    list: prev.list.filter((res) => res !== book),
                  }))
                }
              />
            ))}
          </Stack>
        </Stack>
      </form>

      <DialogActions>
        <LoadingButton
          form={"customizeForm"}
          loading={addBookGroupLoading}
          type="submit"
          variant="contained"
          color="secondary"
          size="large"
        >
          Submit
        </LoadingButton>
      </DialogActions>
    </>
  );
};

export default CustomizeBookContent;
